export class CsvValidation {
    public static readonly DEFAULT_OPTIONS: CsvValidationOptions = {
        lineSeparator: /\r?\n/,
        fieldSeparator: /,/
    }

    public readonly lines: CsvLine[] = [];
    public valid: boolean = true;

    public apply(text: string, options: CsvValidationOptions = CsvValidation.DEFAULT_OPTIONS): CsvValidation {
        this.lines.length = 0;
        const lines = text.split(options.lineSeparator);
        
        lines.forEach((line, lineIndex) => {
            const fields: string[] = [];
            let currentField = '';
            let inQuotes = false;
    
            for (let i = 0; i < line.length; i++) {
                const char = line[i];
                if (char === '"') {
                    inQuotes = !inQuotes;
                } else if (char === ',' && !inQuotes) {
                    fields.push(this.cleanField(currentField));
                    currentField = '';
                } else {
                    currentField += char;
                }
            }
            fields.push(this.cleanField(currentField));
    
            const csvFields = fields.map((value, index) => new CsvField(value, index));
            this.lines.push(new CsvLine(csvFields, lineIndex));
        });
    
        return this;
    }
    
    private cleanField(field: string): string {
        return field.trim().replace(/^"|"$/g, '');
    }

    public validate(constraints: Map<number, CsvConstraint>): void {
        this.lines.forEach(csvLine => {
            if (csvLine.fields.length !== constraints.size) {
                csvLine.valid = false;
            }
            csvLine.fields.forEach(csvField => {
                if (!constraints.get(csvField.position)?.regExp.test(csvField.value)) {
                    csvField.valid = false;
                    csvLine.valid = false;
                    this.valid = false;
                }
            })
        });
    }

    public getInvalidLines(): CsvLine[] {
        return this.lines.filter(csvLine => !csvLine.valid);
    }

    public getInvalidFields(csvLine: CsvLine): CsvField[] {
        return csvLine.fields.filter(csvField => !csvField.valid);
    }
}

export class CsvLine {
    constructor(fields: CsvField[], position: number) {
        this.fields = fields;
        this.position = position;
    }
    public readonly fields: CsvField[];
    public readonly position: number;
    public valid: boolean = true;
}

export class CsvField {
    constructor(value: string, position: number) {
        this.value = value;
        this.position = position;
    }
    public readonly value: string;
    public readonly position: number;
    public valid: boolean = true;
}

export class CsvConstraint {

    constructor(regExp: RegExp, description: string) {
        this.regExp = regExp;
        this.description = description;
    }

    public readonly regExp: RegExp;
    public readonly description: string;
}

export type CsvValidationOptions = {
    lineSeparator: string | RegExp;
    fieldSeparator: string | RegExp;
}
